import React from 'react';
import Icon from '../../../components/AppIcon';

const InvitationHeader = ({ invitationValid, invitedRole, invitedEmail }) => {
  if (!invitationValid) {
    return (
      <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-4 md:p-6 mb-6 md:mb-8">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-destructive/20 rounded-full flex items-center justify-center">
            <Icon name="AlertCircle" size={20} color="var(--color-destructive)" />
          </div>
          <div className="flex-1">
            <h3 className="text-base md:text-lg font-semibold text-destructive mb-2">Invalid or Expired Invitation</h3>
            <p className="text-sm md:text-base text-destructive/80 mb-3">
              This invitation link is no longer valid or has expired. Please contact your administrator to request a new invitation.
            </p>
            <p className="text-xs md:text-sm text-muted-foreground">
              If you believe this is an error, please reach out to support@viderasurgical.com
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-success/10 border border-success/20 rounded-lg p-4 md:p-6 mb-6 md:mb-8">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-success/20 rounded-full flex items-center justify-center">
          <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
        </div>
        <div className="flex-1">
          <h3 className="text-base md:text-lg font-semibold text-success mb-2">Invitation Confirmed</h3>
          <p className="text-sm md:text-base text-foreground mb-2">
            You've been invited to join Videra Surgical Providers Portal as a <span className="font-semibold">{invitedRole === 'provider' ? 'Provider' : 'Practice Marketer'}</span>.
          </p>
          <p className="text-xs md:text-sm text-muted-foreground">
            Email: <span className="font-medium text-foreground">{invitedEmail}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvitationHeader;